import { CancelButton, ConfirmationButton } from '../Button';
import React, { useContext } from 'react';
import { StepperContext } from './index';
import { ReactComponent as ArrowCircle } from '../../assets/images/icons/ico_arrow_circle.svg';

const onClickPrevious = (stepperState, setStepperState) => {
	const { currentIndex, elements, steps } = stepperState;
	const previousIndex = Math.max(0, currentIndex - 1);

	steps[elements[previousIndex].step]['validated'] = false;

	setStepperState({
		...stepperState,
		currentIndex: previousIndex,
		currentStep: elements[previousIndex].step
	});
};

const onClickNext = (stepperState, setStepperState, nextState = null) => {
	const { currentIndex, currentStep, elements, steps } = stepperState;
	const nextIndex = Math.min(elements.length - 1, currentIndex + 1);

	if (elements[nextIndex].step !== currentStep) {
		steps[currentStep]['validated'] = true;
	}

	setStepperState({
		...stepperState,
		currentIndex: nextState?.nextIndex ?? nextIndex,
		currentStep: nextState?.step ?? elements[nextIndex].step
	});
};

const NextButton = ({ label, onClick, ...props }) => {
	const { stepperState, setStepperState } = useContext(StepperContext);
	const { currentIndex, elements } = stepperState;
	return (
		<ConfirmationButton
			icon={
				<ArrowCircle fill="white" style={{ transform: 'rotate(180deg)' }} />
			}
			onClick={
				onClick
					? onClick
					: () => {
							onClickNext(stepperState, setStepperState);
					  }
			}
			label={
				label ||
				(elements.length === currentIndex + 1 ? 'Finalizar' : 'Siguiente')
			}
			{...props}
		/>
	);
};

const PreviousButton = ({ label, onClick, ...props }) => {
	const { stepperState, setStepperState } = useContext(StepperContext);
	return (
		<CancelButton
			icon={<ArrowCircle fill="#7A7886" />}
			onClick={
				onClick
					? onClick
					: () => {
							onClickPrevious(stepperState, setStepperState);
					  }
			}
			label={label || 'Regresar'}
			{...props}
		></CancelButton>
	);
};

const IrAFinalizadoButton = ({
	formik,
	setAction = (_) => {},
	ignoreValidation = false,
	...props
}) => {
	const { stepperState, setStepperState } = useContext(StepperContext);
	return stepperState.edit ? (
		<ConfirmationButton
			onClick={(e) => {
				formik.handleSubmit(e);
				setAction({
					id: 'finalizado',
					fn: () => {
						setStepperState({
							...stepperState,
							currentStep: 'finalizado',
							currentIndex: stepperState.elements.length - 1,
							edit: false
						});
					}
				});
			}}
			color="finalizado"
			disabled={formik.isSubmitting}
			label={'Ir a finalizado'}
			{...props}
		/>
	) : (
		<></>
	);
};

export {
	NextButton,
	PreviousButton,
	IrAFinalizadoButton,
	onClickPrevious,
	onClickNext
};
